import React from "react";
import { Card, CardBody, FormGroup, Label } from "reactstrap";
import { useEtim } from "../../context/ETIMContext";
import { FormattedMessage } from "react-intl";

export default function EtimHeader({ title, children }) {
  const { etim } = useEtim();
  return (
    <Card className="etim-header mb-3 selected-series blur">
      <CardBody className="p-2">
        <FormGroup row className="m-0 d-flex flex-row align-items-center">
          <div className="d-flex">
            <Label className="my-0 ml-3 mr-5 font-weight-bold">
              <FormattedMessage id="selected_series.specified_series_title" defaultMessage="Specified series" className="bold" />
            </Label>
            {etim.seriesId && (
              <div className="d-flex align-items-center mr-3">
                <div className="ml-3">
                  <small>{etim.seriesName}</small>
                </div>
              </div>
            )}
          </div>
          <div className="d-flex">
            <Label className="my-0 ml-5 mr-5 font-weight-bold">
              <FormattedMessage id="etim.version" defaultMessage="Version" />
            </Label>
            <div className="d-flex align-items-center">
              <div className="ml-3">
                <small>{etim.version ?? "-"}</small>
              </div>
            </div>
          </div>
        </FormGroup>
      </CardBody>
    </Card>
  );
}
